var _excluded = ["checked", "className", "disabled", "fieldSize", "id", "label", "labelPosition", "tabIndex"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled, { css } from 'styled-components';
import * as IconSet from "../../../icons/index.js";
import Icon from "../../basic/Icon/Icon.js";
import FieldLabel from "../FieldLabel/FieldLabel.js";
/* INVISIBLE Checkbox input */
var CheckboxInput = styled.input.withConfig({
  componentId: "CL__sc-1jve5gz-0"
})(["clip-path:inset(50%);clip:rect(0 0 0 0);height:1px;margin:0;overflow:hidden;position:absolute;white-space:nowrap;width:1px;"]);
var StyledSwitch = styled.span.withConfig({
  componentId: "CL__sc-1jve5gz-1"
})(["background-color:var(--gray-3);border-radius:calc(var(--switch-height) / 2);display:inline-block;height:var(--switch-height);padding:var(--switch-padding);position:absolute;transition:background-color var(--hover-transition) var(--transition-easing);width:var(--switch-width);"]);
var StyledHandle = styled.span.withConfig({
  componentId: "CL__sc-1jve5gz-2"
})(["align-items:center;background-color:var(--main-bkg-color);border:var(--border-size) solid var(--main-bkg-color);border-radius:calc(var(--handle-size) / 2);display:flex;height:var(--handle-size);justify-content:center;transform:rotate(-180deg);transition-duration:var(--hover-transition);transition-property:border-color,transform;transition-timing-function:var(--transition-easing);width:var(--handle-size);"]);
var StyledIcon = styled(Icon).withConfig({
  componentId: "CL__sc-1jve5gz-3"
})(["--icon-size:", ";line-height:1;"], _ref => {
  var {
    checked
  } = _ref;
  return checked ? 'var(--icon-size-override-checked)' : 'var(--icon-size-override)';
});
var StyledFieldLabel = styled(FieldLabel).withConfig({
  componentId: "CL__sc-1jve5gz-4"
})(["align-items:center;cursor:inherit;display:flex;padding:0;position:relative;width:100%;"]);
var getVariantCssVars = _ref2 => {
  var {
    fieldSize
  } = _ref2;
  switch (fieldSize) {
    case 'large':
      return css(["--border-size:2px;--icon-size-override:18px;--icon-size-override-checked:26px;--switch-height:36px;--switch-margin-x:var(--spacing-2);--switch-margin-y:var(--spacing-1);--switch-padding:var(--spacing-1);"]);
    case 'medium':
      return css(["--border-size:2px;--icon-size-override:16px;--icon-size-override-checked:22px;--switch-height:30px;--switch-margin-x:calc(var(--spacing-1) * 1.3334);--switch-margin-y:var(--spacing-1);--switch-padding:calc(var(--spacing-1) * 0.6667);"]);
    default:
      return css(["--border-size:1px;--icon-size-override:12px;--icon-size-override-checked:16px;--switch-height:24px;--switch-margin-x:var(--spacing-1);--switch-margin-y:calc(var(--spacing-1) * 0.5);--switch-padding:calc(var(--spacing-1) * 0.6667);"]);
  }
};
var SwitchContainer = styled.div.withConfig({
  componentId: "CL__sc-1jve5gz-5"
})(["", ";cursor:pointer;position:relative;", " ", " ", " --handle-size:calc(var(--switch-height) - var(--switch-padding) * 2);--switch-width:calc(var(--handle-size) * 2 + var(--switch-padding) * 2);&:hover ", ":not(:disabled) + ", " ", "{border-color:var(--highlight-color);color:var(--highlight-color);}&:active ", ",& ", ":focus-visible + ", "{box-shadow:0 0 5px var(--highlight-color);", "{border-color:var(--highlight-color);color:var(--highlight-color);}}& ", ":checked + ", "{background-color:var(--green-core);}& ", ":checked + ", " ", "{transform:translateX(100%) rotate(-360deg);}", ""], _ref3 => {
  var {
    fieldSize
  } = _ref3;
  return getVariantCssVars({
    fieldSize
  });
}, _ref4 => {
  var {
    labelPosition
  } = _ref4;
  return labelPosition === 'right' && css(["", "{height:var(--switch-height);padding:0 0 0 calc(var(--switch-width) + var(--switch-margin-x));}"], StyledFieldLabel);
}, _ref5 => {
  var {
    labelPosition
  } = _ref5;
  return labelPosition === 'left' && css(["", "{right:0;}", "{height:var(--switch-height);justify-content:flex-end;padding:0 calc(var(--switch-width) + var(--switch-margin-x)) 0 0;}"], StyledSwitch, StyledFieldLabel);
}, _ref6 => {
  var {
    labelPosition
  } = _ref6;
  return labelPosition === 'top' && css(["", "{bottom:0;}", "{padding:0 0 calc(var(--switch-height) + var(--switch-margin-y)) 0;}"], StyledSwitch, StyledFieldLabel);
}, CheckboxInput, StyledSwitch, StyledHandle, StyledSwitch, CheckboxInput, StyledSwitch, StyledHandle, CheckboxInput, StyledSwitch, CheckboxInput, StyledSwitch, StyledHandle, _ref7 => {
  var {
    disabled
  } = _ref7;
  return disabled && css(["cursor:default;opacity:0.5;"]);
});
var Switch = /*#__PURE__*/React.forwardRef((_ref8, ref) => {
  var {
      checked,
      className,
      disabled,
      fieldSize = 'medium',
      id,
      label,
      labelPosition = 'right',
      tabIndex = 0
    } = _ref8,
    props = _objectWithoutProperties(_ref8, _excluded);
  return /*#__PURE__*/React.createElement(SwitchContainer, {
    className: className,
    disabled: disabled,
    fieldSize: fieldSize,
    labelPosition: labelPosition
  }, /*#__PURE__*/React.createElement(CheckboxInput, _extends({
    checked: checked,
    disabled: disabled,
    id: id,
    ref: ref,
    tabIndex: tabIndex,
    type: "checkbox"
  }, props)), /*#__PURE__*/React.createElement(StyledSwitch, null, /*#__PURE__*/React.createElement(StyledHandle, null, /*#__PURE__*/React.createElement(StyledIcon, {
    "aria-hidden": "true",
    checked: checked,
    component: checked ? IconSet.Checkmark : IconSet.Close
  }))), /*#__PURE__*/React.createElement(StyledFieldLabel, {
    fieldSize: fieldSize,
    htmlFor: id
  }, label));
});
export default Switch;